import { Avatar, AvatarProps } from '@vimeo/bokeh';

import { ANONYMOUS_USER_ICON } from './constants';

export const MentionUserAvatar = ({
  size = 'sm',
  src = ANONYMOUS_USER_ICON,
  ...avatarProps
}: AvatarProps) => (
  <Avatar {...avatarProps} src={src} size={size} style={{ display: 'flex', overflow: 'visible' }} />
);
